import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { EntityTeamRosterHeader } from '../EntityTeamRosterHeader/EntityTeamRosterHeader';
import { EntityTeamLeadershipCard } from '../EntityTeamLeadershipCard/EntityTeamLeadershipCard';
import {
  EntityTeamMembersCard,
  MEMBER_FIELDS,
} from '../EntityTeamMembersCard/EntityTeamMembersCard';
import { useTeamMemberEntities } from '../shared/useTeamMemberEntities';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
  },
}));

/** Groups the roster header with the Leadership and Members cards inside one
 * visual container, so the "Team (N)" total reads as the sum of the two
 * cards beneath it rather than an unrelated card above them.
 *
 * Fetches member entities once here and passes the result to both the header
 * and the Members card — otherwise each would issue its own
 * `getEntitiesByRefs` call for the same group on every page load. */
export function EntityTeamRosterSection() {
  const classes = useStyles();
  const members = useTeamMemberEntities(MEMBER_FIELDS);
  // Mirrors EntityTeamMembersCard's own empty condition: keep the two-column
  // layout while loading/erroring (the card still has something to show —
  // a spinner or an error panel), and only collapse to full width once we
  // know for certain there's nothing to render there.
  const showMembersColumn =
    members.loading || Boolean(members.error) || members.items.length > 0;

  return (
    <Paper variant="outlined" className={classes.paper}>
      <EntityTeamRosterHeader members={members} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={showMembersColumn ? 6 : undefined}>
          <EntityTeamLeadershipCard />
        </Grid>
        {showMembersColumn && (
          <Grid item xs={12} md={6}>
            <EntityTeamMembersCard members={members} />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}
